import React, { FC } from 'react';
import icons from 'style';
import { LockIconSVG } from 'style/styled-components/reusable.css';
import { DescriptionWrapper, InfoWrapper, MetaData, Title } from 'components/Cards/Card/Card.css';

type PropTypes = {
    title: string;
    isLocked?: boolean;
    showDescription: boolean;
    description?: string;
    metaData?: string;
    hideTitleFromScreenReaders?: boolean;
};

export const CardInfo: FC<PropTypes> = ({ title, isLocked, showDescription, description, metaData, hideTitleFromScreenReaders }) => {
    const hasDescription = !!description;

    return (
        <InfoWrapper hasDescription={hasDescription}>
            <Title data-test-id={'tv-detailscreen-episodetitle'} aria-hidden={hideTitleFromScreenReaders || undefined}>
                {isLocked && <LockIconSVG svg={icons.lockIcon} />}
                {title}
            </Title>
            {showDescription && <DescriptionWrapper>{description}</DescriptionWrapper>}
            {metaData != null && <MetaData hasDescription={hasDescription}>{metaData}</MetaData>}
        </InfoWrapper>
    );
};
